import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
  title?: string;
  subtitle?: string;
}

export function FAQ({ items, title = "Perguntas Frequentes", subtitle }: FAQProps) {
  return (
    <section className="section-padding" style={{ backgroundColor: '#edeff3' }}>
      <div className="container-narrow">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-headline font-bold mb-4">{title}</h2>
          {subtitle && (
            <p className="text-body-lg text-muted-foreground max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
        </div>
        <Accordion type="single" collapsible className="w-full space-y-3 sm:space-y-4">
          {items.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-background border border-border rounded-lg px-4 sm:px-6"
            >
              <AccordionTrigger className="text-left font-medium hover:no-underline py-4 sm:py-5 text-sm sm:text-base touch-target">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-4 sm:pb-5 text-sm sm:text-base">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
